export const languages = {
    sv: 'Swedish',
    da: 'Danish',
    no: 'Norwegian',
    pl: 'Polish',
    is: 'Icelandic',
    en: 'English',
    fi: 'Finnish',
    de: 'German',
    fr: 'French',
    it: 'Italian',
    es: 'Spanish',
    nl: 'Dutch',
    pt: 'Portuguese',
    lt: 'Lithuanian',
    et: 'Estonian',
    lv: 'Latvian',
    uk: 'Ukrainian',
    zh: 'Chinese',
    'zh-hant': 'Chinese (Traditional)',
    hu: 'Hungarian',
    sk: 'Slovak',
    ro: 'Romanian',
    hr: 'Croatian',
    mk: 'Macedonian',
    sl: 'Slovenian',
    sq: 'Albanian',
    sr: 'Serbian',
    cs: 'Czech',
    bg: 'Bulgarian',
    tr: 'Turkish',
    ar: 'Arabic',
    he: 'Hebrew',
    ru: 'Russian',
};

export const countryRegions = {
    al: 'Albania',
    at: 'Austria',
    be: 'Belgium',
    bg: 'Bulgaria',
    cn: 'China',
    cz: 'Czechia',
    de: 'Germany',
    dk: 'Denmark',
    ee: 'Estonia',
    es: 'Spain',
    eu: 'EU',
    fi: 'Finland',
    fr: 'France',
    hr: 'Croatia',
    hu: 'Hungary',
    il: 'Israel',
    is: 'Iceland',
    it: 'Italy',
    lt: 'Lithuania',
    lv: 'Latvia',
    mk: 'Macedonia',
    nl: 'Netherlands',
    no: 'Norway',
    pl: 'Poland',
    pt: 'Portugal',
    ro: 'Romania',
    rs: 'Serbia',
    ru: 'Russia',
    sa: 'Saudi Arabia',
    se: 'Sweden',
    si: 'Slovenia',
    sk: 'Slovakia',
    tr: 'Turkey',
    tw: 'Taiwan',
    ua: 'Ukraine',
    xk: 'Kosovo',
};

export const textTypes = {
    description: 'Description',
    application: 'Application',
    product_use: 'Product Use',
    treatment: 'Treatment',
    substrate: 'Substrate',
    h_sentence: 'Health Safety Sentence',
    clp_pictogram: 'CLP Pictogram',
    expected_result: 'Expected Result',
    please_note: 'Please Note',
    supplementary_info: 'Supplementary Information',
    environmental_information: 'Environmental Information',
    dilution: 'Dilution',
    storage: 'Storage',
    usp: 'Unique Selling Points',
};

export const fileTypes = {
    // Both wetgoods and drygoods
    sds: 'SDS - Safety Data Sheet',
    tds: 'TDS - Technical Data Sheet',
    dop: 'DoP - Declaration of Performance',
    efd: 'EFD - Environmental Footprint Declaration',
    eutax: 'EUTax - EU Taxonomy Declaration',
    dgnbdk: 'DGNB-DK-2023',
    dgnbdk25: 'DGNB-DK-2025',
    breeamnor: 'BREEAM NOR - HEA02',
    doc: 'DoC - Declaration of Compliance',

    // Wetgoods only
    fdv: 'FDV - Operation and Maintenance',
    co2md: 'CO₂ Manufacture Declaration',
    epd: 'EPD - Environmental Product Declaration',
    'pl-h-cert': 'ATEST Higieniczny - Hygienic Certificate',
    bvd: 'BVD - Byggvarudeklaration',
    aan: 'AAN - Asthma Allergy Nordic',
    ddb: 'DDB - Detergent Data Sheet',
    leed: 'LEED Green Building Declaration',
    m1: 'M1 - Emission Classification of Building Materials',
    sed: 'SED - Sustainability Environmental Datasheet',

    // Drygoods only
    fsc: 'FSC', // Not sure this exists as a document
};
